module.exports = __webpack_public_path__ + "img/login_background.9bfc63f7.jpg";